import styled from 'styled-components';
import { Button, Input, Radio } from 'antd';

export const CustomInput = styled(Input)<{ $borderRadius?: string }>`
	gap: 8px;
	height: 2.5em;
	width: 100%;
	border: 1px;
	border-radius: ${({ $borderRadius, theme }) => $borderRadius ?? theme.border.input.radius};

	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_sm};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	.ant-input {
		margin-left: 7px;
	}
`;

export const CustomButton = styled(Button)<{ $borderRadius?: string }>`
	border-radius: ${({ $borderRadius }) => $borderRadius ?? '7px'};
	min-width: 120px;
`;

export const IconButton = styled(Button)<{ $borderRadius?: string }>`
	border-radius: ${({ $borderRadius }) => $borderRadius ?? '7px'};
	width: 20px;
	height: 16px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		fill: #000;
	}
`;

export const RadioGroupCustom = styled(Radio.Group)`
	display: flex;
	justify-content: space-evenly;
	.ant-radio-button-wrapper {
		border-radius: 7px !important;
		:last-child {
			border-left: 1px solid #d9d9d9;
		}
		::before {
			display: none;
		}
	}
	&::before {
		display: none;
	}
`;
